export default "__VITE_ASSET__jHa387Qu__"